import React from "react";

export const TypingIndicator: React.FC = () => {
  return (
    <div className="pl-1 mt-2">
      <style>
        {`
          @keyframes chatDotPulse {
            0%, 80%, 100% {
              opacity: 0.3;
              transform: scale(0.8);
            }
            40% {
              opacity: 1;
              transform: scale(1.2);
            }
          }
        `}
      </style>
      <div className="flex items-center space-x-0.5">
        <div
          className="w-1 h-1 rounded-full"
          style={{
            backgroundColor: "white",
            animation: "chatDotPulse 1.4s infinite",
            animationDelay: "0s",
          }}
        ></div>
        <div
          className="w-1 h-1 rounded-full"
          style={{
            backgroundColor: "white",
            animation: "chatDotPulse 1.4s infinite",
            animationDelay: "0.47s",
          }}
        ></div>
        <div
          className="w-1 h-1 rounded-full"
          style={{
            backgroundColor: "white",
            animation: "chatDotPulse 1.4s infinite",
            animationDelay: "0.94s",
          }}
        ></div>
      </div>
    </div>
  );
};
